import { Close } from "@mui/icons-material";
import React, { useState } from "react";
import {
  Checkbox,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useCreateNotificationMutation } from "../../api/notificationApi";
import { useGetEmployeesListQuery } from "../../api/notificationApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getToken } from "../../services/Token";

const CreateNotification = ({ setShowCreateDialog, showCreateDialog }) => {
  const id = getToken("userId");
  const [createForm, setCreateForm] = useState({
    type: "",
    audienceType: "",
    audienceIds: [],
    text: "",
    Publisher: id,
  });
  const [dropdownOpen, setDropdownOpen] = useState({
    type: false,
    audienceType: false,
    audienceIds: false,
  });
  const { employeesList } = useSelector((state) => state.notification);

  const audienceIds = employeesList
    ? employeesList.filter((employee) => {
        if (createForm.audienceType === "EMPLOYEE") return employee?.role === "EMPLOYEE";
        if (createForm.audienceType === "MANAGER") return employee?.role === "MANAGER";
        return true;
      })
    : [];
  const [createNotification] = useCreateNotificationMutation();
  useGetEmployeesListQuery();

  const typeOptions = ["LEAVE", "TIMESHEET", "ATTENDANCE", "PAYROLL"];
  const audienceTypeOptions = ["EMPLOYEE", "MANAGER", "ALL"];

  const handleCreateNotification = async () => {
    try {
      await createNotification(createForm);
      setShowCreateDialog(false);
      setCreateForm({
        type: "",
        audienceType: "",
        audienceIds: [],
        text: "",
      });
      toast.success("Notification created successfully");
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setCreateForm({
      ...createForm,
      audienceIds:
        typeof value === "string" ? value.split(",").map(Number) : value,
    });
  };

  const getNamesByIds = (ids) =>
    audienceIds
      .filter((option) => ids.includes(option.employeeId))
      .map((option) => option.name)
      .join(", ");

  return (
    <div>
      {showCreateDialog && (
        <>
          <button
            className="fixed inset-0 bg-black bg-opacity-50 z-60 transition-opacity duration-300"
            onClick={() => setShowCreateDialog(false)}
          />

          <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
              <div className="flex items-center justify-between p-6 border-b border-gray-100">
                <h3 className="text-xl font-semibold text-gray-800">
                  Create New Notification
                </h3>
                <button
                  onClick={() => setShowCreateDialog(false)}
                  className="p-2 rounded-full hover:bg-gray-100 transition-colors duration-200"
                >
                  <Close className="w-5 h-5 text-gray-500" />
                </button>
              </div>

              <div className="p-6 space-y-6">
                <div>
                  <label
                    htmlFor="type"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Type <span className="text-red-500">*</span>
                  </label>

                  <select
                    id="type"
                    value={createForm.type}
                    onChange={(e) =>
                      setCreateForm((prev) => ({
                        ...prev,
                        type: e.target.value,
                      }))
                    }
                    className="hover:border-gray-600 !font-normal cursor-pointer w-full p-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                  >
                    <option value="">Select notification type</option>
                    {typeOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label
                    htmlFor="audienceType"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Audience Type <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="audienceType"
                    value={createForm.audienceType}
                    onChange={(e) =>
                      setCreateForm((prev) => ({
                        ...prev,
                        audienceType: e.target.value,
                        audienceIds: [],
                      }))
                    }
                    className="w-full !font-normal text-gray-700 p-3 bg-white border border-gray-300 rounded-lg hover:border-gray-600 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                  >
                    <option value="">Select audience type</option>
                    {audienceTypeOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="text font-medium text-gray-700">
                  <label
                    htmlFor="audienceIds"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Audience IDs <span className="text-red-500">*</span>
                  </label>

                  <Select
                    className="w-full !rounded-lg"
                    multiple
                    value={createForm.audienceIds}
                    onChange={handleChange}
                    input={<OutlinedInput />}
                    displayEmpty
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300,
                          overflow: "auto",
                        },
                      },
                    }}
                    renderValue={(selected) =>
                      selected.length === 0 ? (
                        <p className="mt-1 text-gray-700">Select Audience</p>
                      ) : (
                        getNamesByIds(selected)
                      )
                    }
                  >
                    <MenuItem disabled value="">
                      <p>Select Audience</p>
                    </MenuItem>
                    {audienceIds?.map((option) => (
                      <MenuItem key={option.employeeId} value={option.employeeId}>
                        <Checkbox
                          checked={createForm?.audienceIds?.includes(option.employeeId)}
                        />
                        <ListItemText primary={option.name} />
                      </MenuItem>
                    ))}
                  </Select>
                </div>

                <div>
                  <label
                    htmlFor="message"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Message <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    value={createForm.text}
                    onChange={(e) =>
                      setCreateForm((prev) => ({
                        ...prev,
                        text: e.target.value,
                      }))
                    }
                    placeholder="Enter notification message..."
                    rows={4}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200 resize-none"
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    {createForm.text.length}/60 characters
                  </p>
                </div>
              </div>

              <div className="flex items-center justify-end space-x-3 p-6 border-t border-gray-100">
                <button
                  onClick={() => setShowCreateDialog(false)}
                  className="px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors duration-200"
                >
                  Cancel
                </button>
                <button
                  onClick={handleCreateNotification}
                  disabled={
                    !createForm.type ||
                    !createForm.audienceType ||
                    createForm.audienceIds.length === 0 ||
                    !createForm.text.trim() ||
                    createForm.text.length > 60
                  }
                  className="px-6 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-medium rounded-lg transition-colors duration-200"
                >
                  Create Notification
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CreateNotification;
